import { ROUTES } from "../../../module/constants";

export const SERVICE_REQUEST_URLS = {
  BASE_URL: ROUTES.SERVICE_REQUEST,
};

export const SERVICE_REQUEST_IDENTIFIER = {
  TYPES: "types",
  FIELDS: "fields",
  REQUEST_STATE: "responseState",
  BAOS: "baos",
  APPLICATIONS: "applications",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
